import { useTranslation } from 'react-i18next';
import cx from 'classnames';
import useDevice from '@/hooks/useDevice';

import styles from './HistoryAmlHeader.module.sass';

const HistoryAmlHeader = () => {
  const { t } = useTranslation();
  const { isMobile } = useDevice();

  const rowClasses = cx(styles.entry, {
    [styles.row]: true,
  });

  if (isMobile) return null;

  return (
    <div className={rowClasses}>
      <div className={`${styles.col} ${styles['col--icon']}`} />
      <div className={`${styles.col} ${styles['col--name']}`}>
        {t('translation.amlhistory_table_name')}
      </div>
      <div className={`${styles.col} ${styles['col--direction']}`}>
        {t('translation.amlhistory_table_direction')}
      </div>
      <div className={`${styles.col} ${styles['col--risky']}`}>
        {t('translation.amlhistory_table_risky')}
      </div>
      <div className={`${styles.col} ${styles['col--status']}`}>
        {t('translation.amlhistory_table_status')}
      </div>
      <div className={`${styles.col} ${styles['col--label']}`}>
        {t('translation.amlhistory_table_block')}
      </div>
      <div className={`${styles.col} ${styles['col--method']}`}>
        {t('translation.amlhistory_table_method')}
      </div>
      <div className={`${styles.col} ${styles['col--actions']}`}>
        <div className={styles.col} />
        <div className={styles.col} />
      </div>
    </div>
  );
};

export default HistoryAmlHeader;
